export const firebaseConfig = {
  apiKey: "AIzaSyBMfk1uR0Sa35Gzw3J7DSbruOmeF-XvRj4",
  authDomain: "like-1t.firebaseapp.com",
  databaseURL: "https://like-1t.firebaseio.com",
  projectId: "like-1t",
  storageBucket: "like-1t.appspot.com",
  messagingSenderId: "514981152272",
  appId: "1:514981152272:web:9a7643a538d049bbd8ac95",
  measurementId: "G-SPHXSKKCQX"
};


